import { render, staticRenderFns } from "./warehouseManagementInfo.vue?vue&type=template&id=0cd6588e&scoped=true&"
import script from "./warehouseManagementInfo.vue?vue&type=script&lang=js&"
export * from "./warehouseManagementInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6588e",
  null
  
)

export default component.exports